import { render, staticRenderFns } from "./TeacherRow.vue?vue&type=template&id=ac3f589a&scoped=true&"
import script from "./TeacherRow.vue?vue&type=script&lang=js&"
export * from "./TeacherRow.vue?vue&type=script&lang=js&"
import style0 from "./TeacherRow.vue?vue&type=style&index=0&id=ac3f589a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3f589a",
  null
  
)

export default component.exports